module.exports = require("vuetify/lib/components/VToolbar");